import { getAwsAuthToken } from "utils/lib/authHelper";
import sysConf from "config"
export async function handleStreamResponse({
  path,
  body,
  onTitle,
  onQuestion,
  onDone,
  onError
}) {
  try {
    const token = await getAwsAuthToken();
    const localUrl = `http://localhost:4000/${path}`;
    const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/${path}`;
    const response = await fetch(prodUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        "x-auth-source": sysConf.isDev ? "test" : "prod",
      },
      body: body,
    });

    if (!response.ok || !response.body) {
      throw new Error('Stream failed to start');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let partial = '';
    let currentEvent = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      partial += decoder.decode(value, { stream: true });
      const lines = partial.split(/\r?\n/);

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line === '') continue;

        if (line.startsWith('event:')) {
          currentEvent = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
          const payload = line.slice(5).trim();
          if (payload === '[DONE]') {
            if (onDone) onDone();
            return;
          }

          try {
            const parsed = JSON.parse(payload);
            if (currentEvent === 'title' && typeof parsed === 'string') {
              onTitle?.(parsed);
            } else if (currentEvent === 'question' && parsed?.type && parsed?.question) {
              onQuestion?.(parsed);
            } else {
              console.warn('Unhandled stream event:', currentEvent, parsed);
            }
          } catch (err) {
            console.error('Failed to parse stream JSON:', payload, err);
          }
        }
      }

      partial = lines[lines.length - 1].endsWith('\n') ? '' : lines[lines.length - 1];
    }
  } catch (err) {
    console.error('Stream error:', err);
    onError?.(err);
  }
}